import styled, { css, ThemeProvider } from 'styled-components'
import { themeGet } from 'styled-system'
import theme from './theme'

export { css, theme, themeGet, ThemeProvider }
export default styled
